import React from 'react';
import './experience.css';
import Card from './CardExp';
import safety from '../../Img/safety.png';

const Experience = () => {
  return (
    <div className='experience' id='Experience'>
     {/*left side*/}
            <div className='awesome'>
                <span>Instrutores</span>
                <span>Equipe N&R</span>
                
            </div>
            {/*right side*/}
            <div className='cards'>
                {/*1 card*/}
                <div style={{ left: '10rem' }}>
                    <Card
                        emoji={safety}
                        heading={'NILSON ANTUNES RIBEIRO'}
                        detail={'- Atua na área de segurança do trabalho há 20 anos - Tecnólogo em Gestão Ambiental - Técnico em Segurança do Trabalho - Bombeiro Civil Credenciado - Instrutor de Empilhadeira - Instrutor de Ponte Rolante - Instrutor de Liquidos Inflamáveis - Instrutor de Espaço confinado - Instrutor de Trabalho em Altura'}/>
                </div>
                {/*2 card*/}
                <div style={{left: '38rem' }}>
                    <Card
                        emoji={safety}
                        heading={'CARLOS ALBERTO FRANCO'}
                        detail={'- Atua na área de Segurança do trabalho a 28 anos - Bombero Civil - Especialista em Atendimento com Produtos Químicos - Técnico de Resgaste - Instrutor do SINTESP - Instrutor de Líquidos Inflamáveis - Instrutor de Espaço Confinado - Instrutor de Trabalho em Altura - Instrutor de Empilhadeira - Instrutor de Liquidos Inflamáveis - Instrutor de Espaço confinado - Instrutor de Trabalho em Altura'}
                    />
                </div>
                {/*3 card*/}
                <div style={{top: '33rem', left: '-18rem' }}>
                <Card
                        emoji={safety}
                        heading={'GEORGE ROBERT PINTO'}
                        detail={'- Atua na área de Segurança do trabalho a 28 anos - Formação nível superior em Administração de Empresas - Pós Graduado Docência em Ensino Superior - Técnico em Segurança do Trabalho - Instrutor de Empilhadeira - Instrutor de Líquidos Inflamáveis - Instrutor de Espaço Confinado - Instrutor de Trabalho em Altura '}
                    />
                    </div>
                     {/*4 card*/}
                <div style={{top: '33rem', left: '10rem' }}>
                <Card
                        emoji={safety}
                        heading={'RICARDO MAGALHÃES DE ANDRADE'}
                        detail={'- Atua na área de Segurança do trabalho a 28 anos - Pós Graduação em Inclusão de surdos e Língua Brasileira de Sinais - Técnico em Segurança do Trabalho - Instrutor de Empilhadeira - Instrutor de Espaço Confinado - Instrutor de Trabalho em Altura - Instrutor de Segurança na Operação com Máquinas Injetoras - Instrutor de Sopradoras de Materiais Plásticos'}
                    />
                    </div>
                       {/*5 card*/}
                <div style={{top: '33rem', left: '38rem' }}>
                <Card
                        emoji={safety}
                        heading={'CLAUDINEI FLAVIO RIBEIRO'}
                        detail={'- Atua na área de elétrica a 28 anos - Engenheiro Eletricista Eletrônico - Formação de MBA - Gerenciamento de Projetos - Pós-Graduação em Engenharia de Processos Indústrias Área de Concentração em Instrumentação Automação e Controle'}
                    />
                    </div>
                    <div style={{top: '65rem', left: '-18rem'}}>
                <Card
                        emoji={safety}
                        heading={'VANDERSON DE PAULA'}
                        detail={'- Bombeiro Civil - Condutor de transporte de Emergência - Instrutor de APH - Instrutor de Empilhadeira'}
                    />
                    </div>
        </div>
        </div>
        
  )
}

export default Experience